<template>
  <div id="app">
    <router-view />
    <ChangePasswordModal
      :visible="$store.state.password.changePasswordModalVisible"
      :user-id="$store.state.user.userId"
      @close="closeChangePasswordModal"
      @password-changed="handlePasswordChanged"
    />
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {
    closeChangePasswordModal() {
      this.$store.dispatch("password/hideChangePasswordModal");
    },
    handlePasswordChanged() {
      // Выходим из системы после смены пароля
      this.$store.dispatch("user/logout");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style lang="scss" src="@/styles/index.scss"></style>
<style lang="scss">
.m0 {
  margin: 0;
}
</style>
